var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.794c0-.284.212-.52.486-.557l.076-.005h9.889L9.877 4.675a.563.563 0 0 1 .73-.852l.064.054 4.537 4.518a.561.561 0 0 1 .166.4v.021a.61.61 0 0 1-.002.033l.002-.055a.565.565 0 0 1-.11.335l-.006.007a.559.559 0 0 1-.049.056l-4.538 4.52a.563.563 0 0 1-.848-.735l.054-.063 3.571-3.557H3.563A.563.563 0 0 1 3 8.794Z"
  })));
};
export default SvgArrowRight;